import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
  pure: true,
  standalone: false,
})
export class CallDurationPipe implements PipeTransform {
  transform(value?: string): string {
    if (!value || isNaN(Number(value))) {
      return '';
    }
    const seconds = Number(value);
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    const parts: string[] = [];

    if (hours) {
      parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
    }
    if (mins) {
      parts.push(`${mins} min${mins > 1 ? 's' : ''}`);
    }
    if (secs || parts.length === 0) {
      parts.push(`${secs} sec${secs > 1 ? 's' : ''}`);
    }

    return parts.join(' ');
  }
}
